import request from '../utils/request.js'
import qs from 'qs'
import router from '@/router/index.js'
import { Message, Loading } from 'element-ui'

//未登录函数复用
function CheckToken(res) {
    if (res.data.code == -1001 || res.data.code == -1002) {
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('userInfo')
        Message.closeAll()
        Message({
            type: 'warning',
            message: '登录失效，请重新登录',
            duration: 1500,
        })
        router.push('/login')
    } else if (res.data.code != 200) {
        Message({
            type: 'warning',
            message: res.data.msg,
            duration: 1500
        })
    }
}

//检验是否登录或登录是否失效
function CheckLogin() {
    return new Promise((resolve, reject) => {
        request.get('/api/Users/checkLogin').then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

//获取二维码
function GetQr() {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/Auth2/GetScanUrl').then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

//轮询
function CheckAxios(data) {
    return new Promise((resolve, reject) => {
        request.get('/api/Auth2/Check?' + qs.stringify(data)).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

//退出登录
function LoginOut() {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在加载",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get('/api/Users/loginOut').then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

export { CheckLogin, GetQr, CheckAxios, LoginOut }